// extracted by mini-css-extract-plugin
module.exports = {"main":"notif_main__3YRw6","refresh":"notif_refresh__1cn7r","close":"notif_close__1iFXi"};